<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col sm="9">
          <h1>Логи СМС</h1>
        </v-col>
        <v-col sm="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-slide-group class="text-right">
            <v-slide-item v-if="filters.created_at.valueFrom || filters.created_at.valueTo">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.created_at.valueFrom = null; filters.created_at.valueTo = null;"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ filters.created_at.valueFrom }}{{filters.created_at.valueFrom && filters.created_at.valueTo ? ' - ' :
                  ''}}{{ filters.created_at.valueTo }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-if="filters.status.value">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.status.value = null"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                Статус: {{ filters.status.value }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Лог пустой"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="smsLogs"
          :options.sync="options"
          :footer-props="footerProps"
          :server-items-length="total"
          :items-per-page="50"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :loading="loading"
          loading-text="Загрузка лога... Подождите пожалуйста"
      >
        <template v-slot:header.created_at>
          Дата отправки<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.created_at.valueFrom || filters.created_at.valueTo}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.status_text>
          Статус<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.status.value}"
                 @click.stop.prevent="filters.status.modal = !filters.status.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
        :z-index="4"
        :value="overlay"
    >
    </v-overlay>
    <v-dialog
        v-model="filters.created_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.created_at.valueFromModal"
                  :return-value.sync="filters.created_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.created_at.valueToModal"
                  :return-value.sync="filters.created_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueTo"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCreatedAtFilter">Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.status.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              :items="statuses"
              v-model="filters.status.tempValue"
              label="Статус"
              :clearable="true"
              outlined
              :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.status.tempValue }}
                  </span>
            </template>
          </v-select>
          <div class="text-right mt-3">

          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setStatusFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.status.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        right
        top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ProductService from './../../api/ProductService'
import CategoryService from './../../api/CategoryService'
import TagService from './../../api/TagService'
import SmsLogService from "@/api/SmsLogService";

export default {
  name: 'SmsLogIndex',
  components: {},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    statuses: [],
    filters: {
      created_at: {
        valueFrom: '',
        valueFromModal: false,
        valueTo: '',
        valueToModal: false,
        tempValueFrom: '',
        tempValueTo: '',
        modal: false,
      },
      status: {
        value: null,
        tempValue: null,
        modal: false,
      },
    },
    snackbarText: '',
    snackbarColor: '',
    overlay: false,
    loading: true,
    phoneQuery: null,
    smsLogs: [],
    total: 0,
    timerId: null,
    search: '',
    options: {},
    footerProps: {
      itemsPerPageText: 'Элементов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [50]
    },
    headers: [
      {
        text: 'Дата отправки',
        value: 'created_at',
      },
      {
        text: 'Статус',
        value: 'status_text',
        sortable: false
      },
      {
        text: 'Тип',
        value: 'type',
        sortable: false
      },
      {
        text: 'Телефон',
        value: 'phone',
        sortable: false
      },
      {
        text: 'Текст',
        value: 'message',
        sortable: false
      },

    ],
  }),
  mounted() {
    let url = new URL(document.documentURI);
    let searchParams = new URLSearchParams(url.search);
    this.search = searchParams.get('phone')
    this.getDataFromApi()

    SmsLogService.listStatuses()
        .then(response => {
          this.statuses = response.data
        })
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.created_at.valueFrom": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.status.value": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    "filters.created_at.valueTo": {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.getDataFromApi()
      }, 700)
    }
  },
  methods: {
    setCreatedAtFilter(e) {
      this.filters.created_at.valueTo = this.filters.created_at.tempValueTo
      this.filters.created_at.valueFrom = this.filters.created_at.tempValueFrom
      this.filters.created_at.modal = false;
    },
    setStatusFilter(e) {
      this.filters.status.value = this.filters.status.tempValue
      this.filters.status.modal = false;

    },
    getDataFromApi() {
      this.loading = true

      const params = {
        page: this.options.page,
        search: this.search,
        status: this.filters.status.value,
        createdAtFrom: this.filters.created_at.valueFrom,
        createdAtTo: this.filters.created_at.valueTo,
        sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
        sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
      }

      SmsLogService.list(params)
          .then(response => {
            this.smsLogs = response.data.data
            this.total = response.data.total

            this.loading = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
